module.exports = __webpack_public_path__ + "static/media/selfie-warning.c26aa480.svg";